import React from "react";
import { Link } from "react-router-dom";
import { Overlay } from "components/generic/layout";
import { auth, candidate } from "routes/paths";

export default ({ children }) => (
  <Overlay
    right={
      <div>
        <Link to={auth.login}>
          <Overlay.Link>Sign in</Overlay.Link>
        </Link>
      </div>
    }
  >
    {children}
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/common/auth/UnsignedLayout/index.js